import { paramCase, capitalCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// @mui
import { Container } from '@mui/material';
// routes

// sections

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import ElectricBoxNewEditForm from './ElectricBoxNewEditForm';
// ----------------------------------------------------------------------

export default function ElectricBoxCreate() {
  const { themeStretch } = useSettings();

  const { pathname } = useLocation();
  const { translate } = useLocales();
  const { name = '' } = useParams();

  const isEdit = pathname.includes('edit');

  return (
    <Page
      title={
        !isEdit ? `${translate('ElectricBox.AddTitle')}` : `${translate('ElectricBox.UpdateTitle')}`
      }
    >
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={
            !isEdit
              ? `${translate('ElectricBox.CreateElectricBox')}`
              : `${translate('ElectricBox.EditElectricBox')}`
          }
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            {
              name: `${translate('ElectricBox.ElectricBoxList')}`,
              href: PATH_DASHBOARD.ElectricBox.list,
            },
            {
              name: !isEdit
                ? `${translate('ElectricBox.New')}`
                : `${translate('ElectricBox.Update')}`,
            },
          ]}
        />
        <ElectricBoxNewEditForm />
      </Container>
    </Page>
  );
}
